import React from "react";
// import styles from "./ProjectsPage.module.css";

import FooterSection from "../../sections/HomePageSection/FooterSection/FooterSection";
import Stox11Project from "../../sections/ProjectsSection/Stox11Project";




const ProjectsPage = () => {
  return (
    <>
      <Stox11Project />
      <FooterSection />
    </>
  );
};

export default ProjectsPage;
